import type { YearTheme } from '../../types';
import { teal, coral, blue, green } from '../../colorRamps';

// 2026 theme — an ocean teal + coral palette for the Andaz Miami Beach setting,
// distinct from the 2025 purple/orange so the year change is visually apparent.
export const theme: YearTheme = {
  primary: teal,
  accent: coral,
  secondary: blue,
  success: green,
};
